import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Modal } from 'react-bootstrap';
import services from '../../services';
import { toast } from 'react-toastify';
import { GET_ALL_USER } from '../../utils/Apifunction';

import Select, { components } from 'react-select';
import { getLocalStorageItem, removeLocalStorageItem } from '../../utils/Localstorage/localStorageUtils';
import { Select as MuiSelect, MenuItem, InputLabel, FormControl } from '@mui/material';
import labelService from '../../services/labelService';
import StatusDropdown from '../Task/StatusDropdown';
import AutomationStatusDropdown from './AutomationStatusSelectDropdown';

const Automation = ({
    onHide,
    show,
    boardName,
    gmailUsers,
    editData,
    editId,
    getAllAutomation,
    setStep,
    setAutomations,
    setEditId,
}) => {
    const [boardSelect, setBoardSelect] = useState('');
    const [boardColumnSelect, setBoardColumnSelect] = useState('');
    const [selectGmailUser, setSelectGmailUser] = useState('');
    const [rule, setRule] = useState('');
    const [userSelect, setUserSelect] = useState('');
    const [activeTab, setActiveTab] = useState('Gmail');
    const [allClient, setAllClient] = useState([]);
    const [editDatas, setEditDatas] = useState(null);
    const [userData, setUserData] = useState([]);
    const [selectedBoardColumn, setSelectedBoardColumn] = useState([]);
    const [automationsData, setAutomationsData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);
    const [duplicateMsg, setDuplicateMsg] = useState('');
    const [selectedType, setSelectedType] = useState();
    const [customPropertyOptions, setCustomPropertyOptions] = useState([]);
    const [boardError, setBoardError] = useState('');
    const [customFieldOptionsByRow, setCustomFieldOptionsByRow] = useState({});
    const [selectedCustomFieldByRow, setSelectedCustomFieldByRow] = useState({});
    const [customFieldLoadingByRow, setCustomFieldLoadingByRow] = useState({});
    const [customFieldErrorByRow, setCustomFieldErrorByRow] = useState({});
    const [runOnExistingEmails, setRunOnExistingEmails] = useState(false);
    const [days, setDays] = useState(1);


    useEffect(() => {
        const getProperties = async () => {
            if (!boardSelect) {
                setCustomPropertyOptions([]);
                return;
            }

            try {
                const response = await services.property.GET_PROPERTY_BY_BOARD_ID(boardSelect);
                const options = (response?.data?.data || []).map((prop) => ({
                    label: prop.property.propertyName,
                    value: prop.id,
                }));

                setCustomPropertyOptions(options);
            } catch (error) {
                console.error(error);
                setCustomPropertyOptions([]);
            }
        };

        getProperties();
    }, [boardSelect]);

    const conditionOptions = [
        { label: 'the subject', value: 'subject' },
        { label: 'the From email address', value: 'sender' },
        { label: 'the To email address', value: 'recipient' },
    ];
    const operatorOptions = [
        { label: 'contains', value: 'contains' },
        { label: 'does not contain', value: 'doesNotContain' },
        { label: 'is', value: 'equals' },
    ];
    const completedConditionOptions = [
        { label: 'the title', value: 'title' },
        { label: 'the list name', value: 'listName' },
        { label: "the customer's email address", value: 'sender' },
        { label: "the customer's email address", value: 'recipient' },
        { label: 'assignee', value: 'assignee' },
    ];
    const ConditionOptions = [
        { label: 'the title', value: 'title' },
        { label: 'the list name', value: 'listName' },
        { label: "the customer's email address", value: 'recipient' },

        { label: 'assignee', value: 'assignee' },
    ];
    const [actionRows, setActionRows] = useState([{ action: '', order: '', boardId: '', entityId: '' }]);

    const initialActionRow = { action: '', order: '', boardId: '', entityId: '', user: '' };

    const initialCondition = {
        field: conditionOptions[0]?.value || '',
        operator: operatorOptions[0]?.value || '',
        value: '',
    };

    const sla_alert_action = [
        {
            label: '🔥 SLA Due',
            value: 'SLA Due',
            color: 'border border-pink-500 text-pink-600 bg-pink-100',
        },
        {
            label: '⚡ SLA Soon',
            value: 'SLA Soon',
            color: 'border border-orange-500 text-orange-600 bg-orange-100',
        },
    ];

    const MultiValue = (props) => {
        const className = props.data.className || '';
        return (
            <div className={`flex items-center rounded-md px-2 py-1 mr-1 mb-1 text-sm ${className}`}>
                <span className="mr-1">{props.data.label}</span>
                <components.MultiValueRemove {...props}>
                    <span {...props.removeProps} className="ml-1 text-red-500 hover:text-red-700 cursor-pointer">
                        ×
                    </span>
                </components.MultiValueRemove>
            </div>
        );
    };

    const Option = (props) => {
        const { className = '', label } = props.data;
        return (
            <components.Option {...props}>
                <div className={`text-sm rounded-md px-2 py-1 w-[120px] ${className}`}>{label}</div>
            </components.Option>
        );
    };

    const customStyles = {
        multiValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: data.color || '#f3f4f6',
            borderRadius: '6px',
            padding: '2px 4px',
        }),
        multiValueLabel: (styles) => ({
            ...styles,
            fontSize: '0.875rem',
            color: '#111827',
        }),
        multiValueRemove: (styles) => ({
            ...styles,
            color: '#ef4444',
            ':hover': {
                backgroundColor: '#fecaca',
                color: '#b91c1c',
            },
        }),
    };

    const formattedOptions = sla_alert_action.map((item) => ({
        label: `# ${item.label}`,
        value: item.value,
        className: item.color || '',
    }));


    const defaultMailConditions = [{ field: 'title', operator: 'equals', value: '' }];

    const defaultNoReplyToCustomerConditions = [{ field: 'customerWaiting', operator: 'moreThanMins', value: '' }];
    const defaultNoReplyFromCustomerConditions = [
        { field: 'customerNotResponding', operator: 'moreThanMins', value: '' },
    ];
    const [conditions, setConditions] = useState([initialCondition]);
    const [syncGmail, setSyncGmail] = useState([]);
    const [selectedMailUser, setSelectedMailUser] = useState();
    const [showAction, setShowAction] = useState();
    const [actions, setActions] = useState(false);
    const [skipInbox, setSkipInbox] = useState(false);
    const [skipReplies, setSkipReplies] = useState(true);
    const [runOnExisting, setRunOnExisting] = useState(false);
    const [existingDays, setExistingDays] = useState('1');
    const [lables, setLables] = useState([]);
    const [preselectedLoaded, setPreselectedLoaded] = useState({});



    useEffect(() => {
        if (show && !editId) {
            setBoardSelect('');
            setBoardColumnSelect('');
            setSelectGmailUser('');
            setRule('');
            setUserSelect('');
            setEditDatas(null);

            removeLocalStorageItem('editGmailUserId')
        }
    }, [show, editId]);

    useEffect(() => {
        if (editDatas && selectedBoardColumn && selectedBoardColumn.length > 0 && editDatas?.condition?.boardListId) {
            setBoardColumnSelect(editDatas?.condition?.boardListId);

        }
    }, [selectedBoardColumn, editDatas]);

    useEffect(() => {
        if (boardSelect) {
            getSELECTED_BOARD(boardSelect);
        }
    }, [boardSelect]);

    const getAllAutomationData = async () => {
        setLoading(true);
        try {
            const response = await services.automations.GET_ALL_AUTOMATIONS();

            if (response) {
                setAutomationsData(response);
            }
        } catch (e) {
            toast.error('Failed to fetch automations');
        }
        setLoading(false);
    };


    const LablesName = async () => {
        const response = await labelService.GET_Label_ALL();

        setLables(response?.data?.labels)
    }

    useEffect(() => {
        getAllAutomationData();
        LablesName();
    }, []);


    const handleLabelChange = (i, value) => {
        if (!value) return updateUser(i, null);

        const selected = JSON.parse(value);
        updateUser(i, {
            id: selected.childId,
            name: selected.name,
            parentId: selected.parentId || undefined,
        });
    };




    const getSELECTED_BOARD = async (boardSelect) => {
        try {
            const { data } = await services.board.SELECTED_BOARD(boardSelect);
            const sortedData = (data || [])
                .slice()
                .sort((a, b) => Number(a.sequence) - Number(b.sequence));
            setSelectedBoardColumn(sortedData);
            setBoardColumnSelect('');
        } catch (e) {
            console.error(e);
        }
    };
    const handleCreate = async () => {
        const payload = buildPayload();

        try {
            const response = !editId
                ? await services.automations.CREATE_AUTOMATIONS(payload)
                : await services.automations.UPDATE_AUTOMATIONS(editId, payload);
            if (response) {
                toast.success(editId ? 'Automations Updated Successfully' : 'Automations Added Successfully');
                setStep(1);
                getAllAutomation && getAllAutomation();

                removeLocalStorageItem('editGmailUserId')
            }
        } catch (e) {
            console.error(e);
        }
    };

    const addCondition = () => {
        const validConditions = Array.isArray(conditions) ? conditions : [];

        let availableOptions = [];

        if (selectedType === 'new') {
            availableOptions = conditionOptions;
        } else if (selectedType === 'itemAdded') {
            availableOptions = completedConditionOptions;
        } else if (selectedType === 'noReplyToCustomer') {
            availableOptions = completedConditionOptions;
        } else if (selectedType === 'noReplyFromCustomer') {
            availableOptions = completedConditionOptions;
        }

        if (availableOptions.length === 0) return;

        const defaultField = availableOptions[0]?.value || '';
        let defaultOperator = operatorOptions[0]?.value || '';


        if (defaultField === 'assignee') {
            defaultOperator = 'equals';
        } else if (defaultField === 'customerWaiting' || defaultField === 'customerNotResponding') {
            defaultOperator = 'moreThanMins';
        }

        setConditions((prev) =>
            Array.isArray(prev)
                ? [
                    ...prev,
                    {
                        field: defaultField,
                        operator: defaultOperator,
                        value: '',
                    },
                ]
                : [
                    {
                        field: defaultField,
                        operator: defaultOperator,
                        value: '',
                    },
                ],
        );
    };

    const removeCondition = (index) => {
        const updated = conditions.filter((_, i) => i !== index);
        setConditions(updated);
    };

    const conditionThenOption = [


        { label: 'move it to the specific list', value: 'createOnList' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
        { label: 'assign it to', value: 'assignTo' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' }


    ];
    const getEditData = async (editId) => {
        try {
            const response = await services.automations.GET_BY_ID_AUTOMATIONS(editId);
            if (response && response.data && response.data.data) {
                const automation = response.data.data;

                setConditions([]);

                setSelectedType(automation?.type);
                setRule(automation?.name);
                const emailResponse = await services.email.Get_The_Linked_Email();
                const formattedOptions =
                    emailResponse?.data?.map((item) => ({
                        value: item.id,
                        label: item.email,
                    })) || [];

                setSyncGmail(formattedOptions);

                if (automation?.type === 'new' && automation?.when?.gmailUserId) {
                    const matchedUser = formattedOptions.find((user) => user.value === automation.when.gmailUserId);
                    if (matchedUser) {
                        setSelectedMailUser(matchedUser);
                    }
                }

                const userConditions = automation.condition.filter((cond) => {
                    // ❌ Hide board auto-generated conditions
                    if (
                        cond.operand === 'board' &&
                        (automation?.type === 'itemAdded' ||
                            automation?.type === 'noReplyToCustomer' ||
                            automation?.type === 'noReplyFromCustomer')
                    ) {
                        return false;
                    }

                    // ❌ Hide the existingInboxMails condition from the UI
                    if (cond.operand === 'existingInboxMails') {
                        return false;
                    }

                    return true;
                });


                setConditions(
                    userConditions.map((cond) => ({
                        field: cond.operand,
                        operator: cond.operator,
                        value:
                            cond.operand === 'assignee' && Array.isArray(cond.value)
                                ? cond.value[0]?.entityId || ''
                                : cond.value,
                    })),
                );

                let boardId = null;
                if (automation?.type === 'new') {
                    const createOnListAction = automation.action.find((a) => a.action === 'createOnList');
                    if (createOnListAction) {
                        boardId = createOnListAction.boardId;
                    }
                } else {
                    const boardCondition = automation.condition.find((cond) => cond.operand === 'board');
                    if (boardCondition) {
                        boardId = boardCondition.value;
                    }
                }

                if (boardId) {
                    setBoardSelect(boardId);

                    getSELECTED_BOARD(boardId);
                }

                const customPropertyToFetch = [];
                const mainActions = automation.action
                    .filter((a) => a.action !== 'subEmailInbox' && a.action !== 'emailInbox')
                    .map((action, i) => {

                        const mappedAction = {
                            action: action.action,
                            order: action.order,
                            customField: action.customField ?? undefined,
                            customProperty: action.customProperty ?? undefined,
                            user: action.action === 'setCustomProperty' ? action.customProperty ?? '' : undefined
                        };

                        if (action.action === 'setCustomProperty') {
                            mappedAction.customProperty = action.customProperty ?? '';

                            mappedAction.customField = Array.isArray(action.customField) ? action.customField : [];
                            mappedAction.user = action.customProperty ?? '';
                            if (Array.isArray(action.customField) && action.customField.length > 0) {
                                setSelectedCustomFieldByRow(prev => ({
                                    ...prev,
                                    [i]: action.customField.map(cf => ({
                                        id: cf.id,
                                        label: cf.label,
                                        color: cf.color
                                    }))
                                }));


                            }

                            if (action.action === 'setCustomProperty' && action.customProperty) {
                                mappedAction.propertyId = action.customProperty;
                                customPropertyToFetch.push({ index: i, propertyId: action.customProperty });
                            }

                        }
                        if (action.action === 'createOnList') {
                            mappedAction.boardId = action.boardId;
                            mappedAction.entityId = action.entityId;
                        } else if (['assignTo', 'unassign'].includes(action.action)) {
                            mappedAction.user = action.entityId;
                        } else if (action.action === 'assignToRoundRobin') {
                            mappedAction.users =
                                action.entityIds?.map((e) => ({
                                    value: e.entityId,
                                    label: e.name,
                                })) || [];
                        } else if (action.action === 'setSlaAlertTag') {
                            mappedAction.entityId = action.entityValue;
                        } else if (
                            ['sendOverdueAlert', 'sendUpcomingAlert', 'sendNotificationTo'].includes(action.action)
                        ) {
                            mappedAction.entityId = action.entityId;
                            mappedAction.message = action.entityValue;
                        } else if (action.action === 'moveToNextList') {

                            mappedAction.action = 'moveToNext';
                        } else if (action.action === 'moveToPreviousList') {

                            mappedAction.action = 'moveToPreviousList';
                        }


                        else if (action.action === 'setEmailLabel') {
                            const findDeepLabel = (nodes, { parentId = null, labelName }) => {
                                const findNodeById = (list, id) => {
                                    for (const n of list || []) {
                                        if (n.id === id) return n;
                                        if (n.children) {
                                            const found = findNodeById(n.children, id);
                                            if (found) return found;
                                        }
                                    }
                                    return null;
                                };

                                const findDeepInSubtree = (root, name) => {
                                    let best = null;
                                    const dfs = (node, parent) => {
                                        if (node.name === name) {
                                            best = { id: node.id, name: node.name, parentId: parent ? parent.id : null };
                                        }
                                        if (node.children) {
                                            for (const child of node.children) dfs(child, node);
                                        }
                                    };
                                    dfs(root, null);
                                    return best;
                                };

                                if (parentId) {
                                    const ancestor = findNodeById(nodes, parentId);
                                    if (!ancestor) return null;
                                    return findDeepInSubtree(ancestor, labelName);
                                }

                                let deepest = null;
                                const dfsAll = (node, parent) => {
                                    if (node.name === labelName) {
                                        deepest = { id: node.id, name: node.name, parentId: parent ? parent.id : null };
                                    }
                                    if (node.children) {
                                        for (const child of node.children) dfsAll(child, node);
                                    }
                                };
                                for (const n of nodes || []) dfsAll(n, null);
                                return deepest;
                            };

                            const matchedLabel = findDeepLabel(lables, {
                                parentId: action.parentId || null,
                                labelName: action.labelName,
                            });

                            mappedAction.user = matchedLabel || {
                                id: null,
                                name: action.labelName,
                                parentId: action.parentId || null,
                            };
                        }




                        else if (action.action === 'markComplete') {
                            mappedAction.action = 'markComplete';
                        } else if (action.action === 'markIncomplete') {
                            mappedAction.action = 'markIncomplete';
                        }

                        return mappedAction;
                    });

                setActionRows(mainActions);
                if (automation?.type === 'new') {
                    const subEmailInboxAction = automation.action.find((a) => a.action === 'subEmailInbox');
                    const emailInboxAction = automation.action.find((a) => a.action === 'emailInbox');
                    setSkipReplies(subEmailInboxAction ? subEmailInboxAction.isProcessed : false);
                    setSkipInbox(emailInboxAction ? emailInboxAction.hasReply : false);
                }
                if (automation?.condition) {
                    const emailInboxAction = automation.condition.find((a) => a.operand === 'existingInboxMails');
                    if (emailInboxAction?.value) {
                        setDays(emailInboxAction?.value);
                    }
                    if (emailInboxAction?.operand == "existingInboxMails") {
                        setRunOnExistingEmails(true);
                    }
                }

                // Fetch custom property options for each row
                for (const item of customPropertyToFetch) {
                    await handlePropertySelect(item.index, item.propertyId);
                }

            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (!editId || !lables?.length) return;
        getEditData(editId);
    }, [editId, lables]);


    useEffect(() => {
        if (editId) {
            getEditData(editId);
        }
    }, [editId]);

    useEffect(() => {
        if (editId && syncGmail.length > 0 && selectedType === 'new') {

            const storedGmailUserId = getLocalStorageItem('editGmailUserId')
            if (storedGmailUserId) {
                const gmailUser = syncGmail.find((user) => user.value === storedGmailUserId);
                if (gmailUser) {
                    setSelectedMailUser(gmailUser);
                }
            }
        }
    }, [syncGmail, editId, selectedType]);


    useEffect(() => {
        GET_ALL_USER_DATA();
        GET_ALL_Whastpp_DATA();
    }, []);

    const GET_ALL_USER_DATA = async () => {
        const response = await GET_ALL_USER();
        response && setUserData(response?.users);
    };

    const handleSelect = (key) => {
        setActiveTab(key);
        setSelectGmailUser('');
    };

    const GET_ALL_Whastpp_DATA = async () => {
        try {
            const { data } = await services.Whatsapp.GET_ALL_CLIENT();
            setAllClient(data || []);
        } catch (e) {
            console.error(e);
        }
    };

    const checkDuplicate = (boardId, gmailUserId) => {
        if (!Array.isArray(automationsData) || !boardId) return false;

        if (selectedType === 'new') {
            if (!gmailUserId) return false;

            return automationsData.some((auto) => {
                if (editId && auto.id === editId) return false;
                const sameType = auto?.type === selectedType;
                const hasBoardInAction = auto?.action?.some((action) => action.boardId === boardId);
                const whenMatchesGmail = auto?.when?.gmailUserId === gmailUserId;
                return sameType && whenMatchesGmail && hasBoardInAction;
            });
        }


        return automationsData.some((auto) => {
            if (auto?.type !== selectedType || (editId && auto.id === editId)) {
                return false;
            }


            const boardInConditions = auto?.condition?.some(
                (cond) => cond.operand === 'board' && cond.value === boardId,
            );


            const boardInActions = auto?.action?.some((action) => action.boardId === boardId);


            const boardInWhen = auto?.when?.boardId === boardId;

            return boardInConditions || boardInActions || boardInWhen;
        });
    };



    const handleBoardChange = (value) => {
        setBoardSelect(value);
        setIsDuplicate(false);
        setDuplicateMsg('');
    };


    const options = userData?.map((user) => ({
        value: user.id,
        label: user.name,
        email: user.email,
    }));
    const availableActions = [
        { label: 'assign it to', value: 'assignTo' },
        { label: 'assign with round robin to', value: 'assignToRoundRobin' },
        { label: 'unassign it', value: 'unassign' },
        { label: 'mark it complete', value: 'markComplete' },
        { label: 'mark it incomplete', value: 'markIncomplete' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' },
    ];

    const addActionRow = () => {
        setActionRows([...actionRows, { action: '', user: '', boardId: '', entityId: '' }]);
    };

    const updateAction = (index, value) => {
        const updated = [...actionRows];

        if (selectedType === 'new' && index === 0) {
            const selectedBoard = boardName.find((b) => b.value === value);

            updated[index].action = 'createOnList';
            updated[index].boardId = value;
            updated[index].entityId = '';
            updated[index].user = '';

            setShowAction(value);
        } else {
            if (boardName.some((b) => b.value === value)) {
                updated[index].boardId = value;
            } else {
                updated[index].action = value;
                updated[index].user = '';
                updated[index].boardId = '';
                updated[index].entityId = '';


                if (value === 'sendOverdueAlert') {
                    updated[index].message = '🔥Overdue - Customer is waiting for a reply.';
                } else if (value === 'sendUpcomingAlert') {
                    updated[index].message = "⚡Upcoming soon - Don't forget";
                } else if (value === 'sendNotificationTo') {
                    updated[index].message = 'Issue escalated to you';
                }
            }
        }

        setActionRows(updated);
    };
    const updateUser = (index, value, isMulti = false) => {
        setActionRows(prev => {
            const updated = [...prev];

            // Ensure no holes in the array
            for (let i = 0; i <= index; i++) {
                if (!updated[i]) {
                    updated[i] = { ...initialActionRow };
                }
            }

            const action = updated[index].action;

            if (action === "assignTo") {
                updated[index].user = value;
            }
            else if (action === "assignToRoundRobin") {
                updated[index].users = value;
            }
            else if (action === "setCustomProperty") {
                updated[index].propertyId = value;
            }

            return updated;
        });
    };


    const showUserSelectFor = ['assignTo', 'assignToRoundRobin', 'setEmailLabel', 'setCustomProperty'];
    const isCustomPropertyUsed = actionRows?.some(
        (row) => showUserSelectFor.includes(row.action) && row.action === 'setCustomProperty'
    );
    useEffect(() => {
        if (isCustomPropertyUsed && !boardSelect) {
            setBoardError('Please select board for custom property');
        } else {
            setBoardError('');
        }
    }, [isCustomPropertyUsed, boardSelect]);
    const shouldHideAddButton =
        ['markComplete', 'markIncomplete'].includes(actionRows[1]?.action) || actionRows.length >= 3;

    const customPropertyThenOption = [
        { label: 'Text (Multiple lines)', value: 'text' },
        { label: 'Team member', value: 'team_member' },
        { label: 'Contact/Company', value: 'contact_company' },
        { label: 'Task', value: 'task' },
        { label: 'Status', value: 'status' },
        { label: 'Tag', value: 'tag' },
        { label: 'Multi-select', value: 'multi_select' },
        { label: 'File', value: 'file' },
        { label: 'URL', value: 'url' },
        { label: 'Email', value: 'email' },
        { label: 'Phone', value: 'phone' },
        { label: 'Location', value: 'location' },
        { label: 'Link', value: 'link' },
        { label: 'Email', value: 'email' },
        { label: 'Phone', value: 'phone' },
        { label: 'Location', value: 'location' },
        { label: 'Link', value: 'link' },
        { label: 'Number', value: 'number' },
        { label: 'Text (Single line)', value: 'text' },
    ];



    const updateConditionField = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, field: value, value: '' };

                    if (value === 'assignee') {
                        newCond.operator = 'equals';
                    } else if (value === 'customerWaiting' || value === 'customerNotResponding') {
                        newCond.operator = 'moreThanMins';
                    }
                    return newCond;
                }
                return cond;
            }),
        );
    };

    const updateConditionOperator = (index, value) => {
        setConditions((prev) =>
            prev.map((cond, i) => (i === index ? { ...cond, operator: value, value: '' } : cond)),
        );
    };

    const updateConditionValue = (index, value) => {
        setConditions((prev) => {
            const updated = prev.map((cond, i) => {
                if (i === index) {
                    const newCond = { ...cond, value };
                    return newCond;
                }
                return cond;
            });
            return updated;
        });
    };

    const updateMessage = (index, value) => {
        const updated = [...actionRows];
        updated[index].message = value;
        setActionRows(updated);
    };

    const buildPayload = () => {
        const staticCondition = {
            field: 'board',
            operator: 'equals',
            value: boardSelect,
        };
        if (runOnExistingEmails) {
            const existing = conditions.find(
                (c) => c.field === "existingInboxMails"
            );

            if (existing) {
                existing.value = days;
            } else {
                conditions.push({
                    field: "existingInboxMails",
                    operator: "lte",
                    value: days,
                });
            }

        } else {
            const index = conditions.findIndex(
                (c) => c.field === "existingInboxMails"
            );

            if (index !== -1) {
                conditions.splice(index, 1);
            }
        }



        let allConditions = conditions;
        if (
            selectedType === 'itemAdded' ||
            selectedType === 'noReplyToCustomer' ||
            selectedType === 'noReplyFromCustomer'
        ) {

            const hasBoardCondition = conditions.some((cond) => cond.field === 'board');
            if (!hasBoardCondition) {
                allConditions = [staticCondition, ...conditions];
            }
        }

        return {

            type: selectedType,
            when: {
                gmailUserId: selectedMailUser ? selectedMailUser?.value : '',
            },
            condition: allConditions.map((c) => ({
                operand: c.field,
                operator: c.operator,
                value: c.field === 'assignee' ? [{ entityId: c.value }] : c.value,
            })),
            action: (() => {
                const baseActions = actionRows.map((a, index) => {
                    let actionName = a.action;


                    if (a.action === 'moveToNext') {
                        actionName = 'moveToNextList';
                    } else if (a.action === 'moveToPreviousList') {
                        actionName = 'moveToPreviousList';
                    }

                    const payload = {
                        action: actionName,
                        order: index,
                    };

                    if (a.action === 'createOnList') {
                        return {
                            ...payload,
                            boardId: a.boardId,
                            entityId: a.entityId,
                        };
                    }

                    if (['assignTo', 'unassign'].includes(a.action)) {
                        return {
                            ...payload,
                            entityId: a.user,
                        };
                    }

                    if (a.action === 'assignToRoundRobin') {
                        return {
                            ...payload,
                            entityIds:
                                a.users?.map((u) => ({
                                    entityId: u.value,
                                    name: u.label,
                                })) || [],
                        };
                    }


                    if (a.action === 'setEmailLabel') {
                        return {
                            ...payload,
                            action: 'setEmailLabel',
                            labelName: a.user ? a.user.name || a.user.label : '',
                            ...(a.user?.parentId ? { parentId: a.user.parentId } : {}),
                        };
                    }

                    if (a.action === 'setCustomProperty') {
                        const customPropertyId = a.user || a.customPropertyId || a.propertyId || '';

                        // Always take the correct array from selectedCustomFieldByRow
                        let customFieldArray = [];

                        if (selectedCustomFieldByRow?.[index]) {
                            // Already correct format: [{id:"..."}, {id:"..."}]
                            customFieldArray = selectedCustomFieldByRow[index];
                        }

                        // Fallback for edit mode (single ID)
                        else if (a.customFieldId || a.entityId || a.selectedCustomFieldId) {
                            customFieldArray = [
                                { id: String(a.customFieldId || a.entityId || a.selectedCustomFieldId) }
                            ];
                        }

                        return {
                            ...payload,
                            action: "setCustomProperty",
                            customProperty: customPropertyId,
                            customField: customFieldArray,
                        };
                    }




                    if (a.action === 'setSlaAlertTag') {
                        return {
                            ...payload,
                            entityValue: a.entityId || [],
                        };
                    }

                    if (
                        a.action === 'sendOverdueAlert' ||
                        a.action === 'sendUpcomingAlert' ||
                        a.action === 'sendNotificationTo'
                    ) {
                        return {
                            ...payload,
                            entityId: a.entityId,
                            entityValue: a.message || '',
                        };
                    }

                    return payload;
                });

                if (selectedType === 'new') {
                    baseActions.push({ action: 'subEmailInbox', isProcessed: skipReplies });
                    baseActions.push({ action: 'emailInbox', hasReply: skipInbox });
                }
                return baseActions;
            })(),
        };
    };

    const updateBoardList = (index, value) => {
        const updated = [...actionRows];
        updated[index].entityId = value;
        setActionRows(updated);
    };

    const handleMailUserChange = (selectedOption) => {
        setSelectedMailUser(selectedOption);
        setIsDuplicate(false);
        setDuplicateMsg('');
    };

    useEffect(() => {
        if (!editId) {
            setSelectedType('new');
        }
    }, []);


    useEffect(() => {
        const gmailUserId = selectedMailUser?.value ?? null;

        if (!selectedType || !boardSelect) {
            setIsDuplicate(false);
            setDuplicateMsg('');
            return;
        }

        if (selectedType === 'new' && !gmailUserId) {
            setIsDuplicate(false);
            setDuplicateMsg('');
            return;
        }
        const duplicate = checkDuplicate(boardSelect, gmailUserId);
        setIsDuplicate(duplicate);
        if (duplicate) {
            if (selectedType === 'new') {
                setDuplicateMsg('Automation already exists for this gmail user and board.');
            } else {
                setDuplicateMsg(`Automation of type "${selectedType}" already exists for this board.`);
            }
        } else {
            setDuplicateMsg('');
        }
    }, [selectedType, boardSelect, selectedMailUser, automationsData, editId]);

    const handleGetSyncGmail = async () => {
        try {
            const response = await services.email.Get_The_Linked_Email();
            const formattedOptions = response?.data?.map((item) => ({
                value: item.id,
                label: item.email,
            }));

            setSyncGmail(formattedOptions);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        handleGetSyncGmail();
    }, []);

    const no_reply_to_customer = [
        { label: 'more than (hours)', value: 'moreThanHrs' },
        { label: 'more than (minutes)', value: 'moreThanMins' },
        { label: 'more than (days)', value: 'moreThanDays' },
        { label: 'Set custom property', value: 'setCustomProperty' },
    ];

    const no_reply_then_condition = [
        { label: 'Set an SLA alert on the card', value: 'setSlaAlertTag' },
        { label: 'Send an overdue alert to', value: 'sendOverdueAlert' },
        { label: 'Send an upcoming alert to', value: 'sendUpcomingAlert' },
        { label: 'Send a notification to', value: 'sendNotificationTo' },
        { label: 'Labels', value: 'setEmailLabel' },
        { label: 'Set custom property', value: 'setCustomProperty' },
    ];

    const selectedIsFields = Array.isArray(conditions)
        ? conditions
            .filter((c, i) => c.operator === 'equals')
            .map((c) => c.field)
            .filter(Boolean)
        : [];

    const selectedActionTypes = actionRows.map((row) => row?.action).filter(Boolean);

    const selectedFirstAction = Array.isArray(actionRows) && actionRows[0]?.action ? actionRows[0].action : null;
    const lastTwoSelected = selectedActionTypes.slice(-2);
    const [searchTerm, setSearchTerm] = useState('');

    function flattenLabels(labels, parentPath = [], parentId = null) {
        let options = [];
        labels.forEach(label => {
            const currentPath = [...parentPath, label.name];
            options.push({
                label: currentPath.join('/'),
                value: JSON.stringify({
                    parentId: parentId,
                    childId: label.id,
                    name: label.name,
                }),
            });
            if (label.children && label.children.length) {
                options = options.concat(flattenLabels(label.children, currentPath, label.id));
            }
        });
        return options;
    }

    const allOptions = useMemo(() => flattenLabels(lables), [lables]);

    const filteredOptions = useMemo(() => {
        if (!searchTerm) return allOptions;
        return allOptions.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
    }, [allOptions, searchTerm]);

    const deleteCustomField = async (id, idx, status) => {
        try {
            await services?.customfield.DELETE_CUSTOEM_FILED(id);
            const propertyId = actionRows[idx]?.propertyId || actionRows[idx]?.customProperty;
            if (propertyId) {
                await handlePropertySelect(idx, propertyId);
            }
        } catch (error) {
            console.error('Failed to delete custom field or refresh properties', error);
        }
    };

    const handlePropertySelect = async (rowIndex, propertyId) => {
        updateUser(rowIndex, propertyId);

        if (!propertyId) {
            setCustomFieldOptionsByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            setSelectedCustomFieldByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            setCustomFieldErrorByRow(prev => {
                const copy = { ...prev };
                delete copy[rowIndex];
                return copy;
            });
            return;
        }

        setCustomFieldLoadingByRow(prev => ({ ...prev, [rowIndex]: true }));
        setCustomFieldErrorByRow(prev => ({ ...prev, [rowIndex]: null }));

        try {
            const response = await services.customfield.GET_CUSTOM_FIELD_BY_TASK_ID(propertyId);

            const options = (response?.data?.data || []).map(item => {
                const cf = item?.customField ?? {};
                const valueField = cf?.value;

                const getLabel = (v) =>
                    typeof v === "object" && v !== null
                        ? v.label ?? v.name ?? v.value ?? ""
                        : (v ?? "");

                const label = Array.isArray(valueField)
                    ? valueField.map(getLabel).join(", ")
                    : getLabel(valueField);

                return {
                    label: label || cf.name || "Unnamed",
                    value: cf.id ?? item?.id ?? "",
                    _rawCustomField: cf,
                    _rawItem: item
                };
            });

            setCustomFieldOptionsByRow(prev => ({ ...prev, [rowIndex]: options }));

            // ❌ previously ""
            setSelectedCustomFieldByRow(prev => ({
                ...prev,
                [rowIndex]: prev[rowIndex] ?? []
            }));


        } catch (err) {
            console.error('Failed to fetch custom fields for property', err);
            setCustomFieldOptionsByRow(prev => ({ ...prev, [rowIndex]: [] }));
            setCustomFieldErrorByRow(prev => ({ ...prev, [rowIndex]: 'Failed to load fields' }));
        } finally {
            setCustomFieldLoadingByRow(prev => ({ ...prev, [rowIndex]: false }));
        }
    };


    const defaultColorMap = {
        Done: '#4ade80',
        'Working on': '#facc15',
        Stuck: '#f87171',
        'Waiting for approval': '#60a5fa',
        default: '#9ca3af',
    };
    const [customeFiedId, setCustomeFieldId] = useState(null);
    const getDefaultColorByValue = (value) => {
        return defaultColorMap[value] || defaultColorMap.default;
    };


    const handleUpdateCell = async (propertyId, newValue, color, idx, flag) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(propertyId);
            const propertyName = response?.data?.data?.property?.name;

            const payload = {
                customPropertyId: propertyId,
                customField: {
                    value: newValue,
                    name: propertyName,
                    color: color,
                },
            };

            const createTag = await services.customfield.CREATE_CUSTOM_FIELD(payload);

            const newField = createTag?.data?.data;
            if (!newField) return;

            const newOption = {
                id: newField.id,
                value: newField.id,
                label: newValue,
                color: color,
                _rawItem: {
                    id: newField.id,
                    customField: {
                        value: newValue,
                        color: color,
                    },
                },
            };

            // ✅ Update dropdown options
            setCustomFieldOptionsByRow(prev => ({
                ...prev,
                [idx]: [...(prev[idx] || []), newOption],
            }));

            // ✅ Update selected values
            setSelectedCustomFieldByRow(prev => ({
                ...prev,
                [idx]: [
                    ...(prev[idx] || []),
                    {
                        id: newField.id,
                        label: newValue,
                        color: color,
                    },
                ],
            }));

            // fetchProperty(propertyId);
        } catch (error) {
            console.error('Failed to create custom field', error);
        }
    };


    const handleUpdatedCustomField = async (propertyId, newValue, color, field, idx) => {
        try {
            const response = await services.property.GET_PROPERTY_BY_ID(propertyId);
            const propertyName = response?.data?.data?.property?.name;

            // 👇 Convert to correct array structure
            const customFieldArray = selectedCustomFieldByRow[idx] || [];
            const data = {
                customPropertyId: propertyId,
                customField: {
                    value: newValue,
                    name: propertyName,
                    color: color,
                },
            };


            const responsedata = await services.customfield.UPDATE_CUSTOM_FIELD(customeFiedId, data);

            if (responsedata?.status === 200) {
                setSelectedCustomFieldByRow(prev => ({
                    ...prev,
                    [idx]: data
                }));
                await handlePropertySelect(idx, propertyId);
            }

            setCustomeFieldId(null);
        } catch (error) {
            console.error('Failed to update custom field', error);
        }
    };


    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        // style={{ scrollbarWidth: 'none' }}
        >
            <Modal.Header closeButton>
                <h2 className="text-[28px] pt-[1vw] px-[1.4vw] font-normal font-google">Create a new automation</h2>
            </Modal.Header>
            <Modal.Body>
                <div className="flex flex-col  h-[470px] overflow-y-auto" style={{ scrollbarWidth: '2px' }}>
                    <div className="bg-white rounded-lg  p-6  w-full ">
                        <div className="flex flex-col gap-3">

                            <div className="flex  gap-3">
                                <span className="font-medium text-gray-700 w-[60px]">When</span>
                                <select
                                    className="px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-blue-500 w-[270px]"
                                    onChange={(e) => {
                                        const type = e.target.value;
                                        setSelectedType(type);
                                        setActionRows([{ action: '', order: '', boardId: '', entityId: '' }]);
                                        setIsDuplicate(false);
                                        setDuplicateMsg('');
                                        setConditions([]);
                                        setSelectedMailUser(null);
                                        if (type === 'itemAdded') {
                                            setConditions(defaultMailConditions);
                                        } else if (type === 'noReplyToCustomer') {
                                            setConditions(defaultNoReplyToCustomerConditions);
                                        } else if (type === 'noReplyFromCustomer') {
                                            setConditions(defaultNoReplyFromCustomerConditions);
                                        } else {
                                            setConditions([
                                                {
                                                    field: conditionOptions[0].value,
                                                    operator: operatorOptions[2].value,
                                                    value: '',
                                                },
                                            ]);
                                        }


                                    }}
                                    value={selectedType}
                                >
                                    <option value="new">a new mail is received</option>
                                    <option value="itemAdded">an item is added / moved to a list</option>

                                    <option value="noReplyToCustomer">there is no reply to a customer</option>
                                    <option value="noReplyFromCustomer">there is no reply from a customer</option>
                                </select>
                                {selectedType == 'new' && (
                                    <>
                                        <input
                                            type="text"
                                            className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                            value="in the mailbox"
                                            readOnly
                                        />
                                        <Select
                                            options={syncGmail}
                                            className="border border-gray-300 rounded  w-[450px]"
                                            value={selectedMailUser}
                                            onChange={handleMailUserChange}
                                        />
                                    </>
                                )}
                            </div>

                            {selectedType === 'new' && (
                                <>
                                    {Array.isArray(conditions) &&
                                        conditions.map((cond, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-1">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'if' : 'and'}
                                                </span>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 w-[270px] bg-white"
                                                    value={cond.field}
                                                    onChange={(e) => updateConditionField(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select a condition...
                                                    </option>
                                                    {conditionOptions
                                                        .filter(
                                                            (opt) =>
                                                                !selectedIsFields.includes(opt.value) ||
                                                                cond.field === opt.value,
                                                        )
                                                        .map((opt, i) => (
                                                            <option key={i} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                </select>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                                    value={cond.operator}
                                                    onChange={(e) => updateConditionOperator(index, e.target.value)}
                                                >
                                                    {operatorOptions.map((op, i) => (
                                                        <option key={i} value={op.value}>
                                                            {op.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 w-[450px] bg-white"
                                                    value={cond.value}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                />

                                                {conditions.length > 1 && (
                                                    <button
                                                        onClick={() => removeCondition(index)}
                                                        className="text-red-500 fonst-bold text-xl"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>
                                    <div>
                                        {actionRows.map((row, i) => (
                                            <div key={i} className="flex items-center gap-3 mb-2 mt-4">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {i == 0 ? 'then' : ' and'}
                                                </span>

                                                {i == 0 ? (
                                                    <>
                                                        <div className="flex items-start gap-4 ">
                                                            <div className="flex flex-col w-[270px]">
                                                                <select
                                                                    className="border border-gray-300 rounded px-3 py-2 w-full bg-white"
                                                                    disabled
                                                                >
                                                                    <option>move it to the board</option>
                                                                </select>
                                                                <div className="h-5" aria-hidden="true" />
                                                            </div>

                                                            <div className="flex flex-col w-[200px]">
                                                                <select
                                                                    className={`border rounded px-3 py-2 w-full bg-white ${boardError ? 'border-red-500' : 'border-gray-300'}`}
                                                                    value={row.boardId || ''}
                                                                    onChange={(e) => {
                                                                        updateAction(i, e.target.value);
                                                                        handleBoardChange(e.target.value);
                                                                    }}
                                                                >
                                                                    <option value="" disabled>
                                                                        Choose a board...
                                                                    </option>
                                                                    {boardName?.map((item) => (
                                                                        <option key={item.value} value={item.value}>
                                                                            {item.label}
                                                                        </option>
                                                                    ))}
                                                                </select>

                                                                <div className="h-5">
                                                                    {boardError && (
                                                                        <p className="text-red-500 text-sm mt-1">
                                                                            {boardError}
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="flex flex-col w-[450px]">
                                                                <select
                                                                    className="border border-gray-300 rounded px-3 py-2 w-full bg-white"
                                                                    value={row.entityId || ''}
                                                                    onChange={(e) => updateBoardList(i, e.target.value)}
                                                                >
                                                                    <option value="" disabled>
                                                                        Choose a list...
                                                                    </option>
                                                                    {selectedBoardColumn &&
                                                                        selectedBoardColumn.map((item, idx) => (
                                                                            <option key={idx} value={item.id}>
                                                                                {item.coloum}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                                <div className="h-5" aria-hidden="true" />
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <select
                                                        className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white mt-3"
                                                        value={row.action}
                                                        onChange={(e) => updateAction(i, e.target.value)}
                                                    >
                                                        <option value="">Select Action</option>

                                                        {(i === 1
                                                            ? availableActions.filter((item) => {
                                                                if (!selectedFirstAction) return true;

                                                                const firstGroup = [
                                                                    'assignTo',
                                                                    'assignToRoundRobin',
                                                                    'unassign',
                                                                ];
                                                                const secondGroup = ['markComplete'];


                                                                if (firstGroup.includes(selectedFirstAction)) {
                                                                    return item.value !== selectedFirstAction;
                                                                }

                                                                if (secondGroup.includes(selectedFirstAction)) {
                                                                    return !secondGroup.includes(item.value);
                                                                }

                                                                return true;
                                                            })
                                                            : availableActions
                                                        )

                                                            .filter((action) => {
                                                                return (
                                                                    !lastTwoSelected.includes(action.value) ||
                                                                    row.action === action.value
                                                                );
                                                            })
                                                            .map((item, idx) => (
                                                                <option key={idx} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ))}
                                                    </select>
                                                )}




                                                {showUserSelectFor.includes(row.action) &&
                                                    (row.action === 'assignToRoundRobin' ? (
                                                        <Select
                                                            isMulti
                                                            options={options}
                                                            className="border border-gray-300  rounded w-[500px] py-[1px] mt-3"
                                                            placeholder="Select users"
                                                            value={row.users || []}
                                                            onChange={(selected) => updateUser(i, selected, true)}
                                                        />
                                                    ) : row.action === "assignTo" ? (
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white mt-3"
                                                            value={row.user}
                                                            onChange={(e) => updateUser(i, e.target.value)}
                                                        >
                                                            <option value="">Select user</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    )
                                                        : row.action === "setEmailLabel" ? (


                                                            <>

                                                                <FormControl fullWidth size="small" className="mt-3" >
                                                                    <InputLabel id={`select-label-${i}`}>Select label</InputLabel>
                                                                    <MuiSelect
                                                                        labelId={`select-label-${i}`}
                                                                        value={
                                                                            row.user && row.user.name
                                                                                ? JSON.stringify({
                                                                                    parentId: row.user.parentId || null,
                                                                                    childId: row.user.id || null,
                                                                                    name: row.user.name,
                                                                                })
                                                                                : ''
                                                                        }
                                                                        label="Select label"
                                                                        onChange={(e) => handleLabelChange(i, e.target.value)}
                                                                    >
                                                                        <MenuItem value="">
                                                                            <em>Select label</em>
                                                                        </MenuItem>
                                                                        {filteredOptions.map(({ label, value }) => (
                                                                            <MenuItem key={value} value={value}>
                                                                                {label}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </MuiSelect>
                                                                </FormControl>
                                                            </>

                                                        ) : row.action === 'setCustomProperty' ? (
                                                            <>
                                                                <select
                                                                    className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white mt-3"
                                                                    value={row.propertyId || row.customProperty}
                                                                    onChange={(e) => handlePropertySelect(i, e.target.value)}
                                                                >
                                                                    <option value="">Select property</option>
                                                                    {customPropertyOptions.map((prop, j) => (
                                                                        <option key={j} value={prop.value}>
                                                                            {prop.label}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <div className="mt-3 w-50">
                                                                    {customFieldLoadingByRow[i] ? (
                                                                        <p className="text-sm text-gray-500">Loading fields...</p>
                                                                    ) : customFieldErrorByRow[i] ? (
                                                                        <p className="text-sm text-red-500">{customFieldErrorByRow[i]}</p>
                                                                    ) : Array.isArray(customFieldOptionsByRow[i]) && customFieldOptionsByRow[i].length > 0 ? (

                                                                        <>


                                                                            <AutomationStatusDropdown idx={i} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                                setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                                    handleUpdatedCustomField
                                                                                } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />

                                                                        </>
                                                                    ) : null}
                                                                </div>
                                                            </>
                                                        ) : null



                                                    )}




                                                {i > 0 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(i, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        {!shouldHideAddButton && (
                                            <a
                                                onClick={addActionRow}
                                                className="text-blue-500 font-bold px-4 py-2  text-decoration-none"
                                                style={{ minWidth: '120px' }}
                                                type="button"
                                            >
                                                + Add action
                                            </a>
                                        )}
                                    </div>
                                </>
                            )}

                            {duplicateMsg && (
                                <div className="flex items-center gap-3 mt-2">
                                    <span className="font-medium text-gray-700 w-[60px]"></span>
                                    <div className="text-red-500 text-sm bg-red-50 border border-red-200 rounded px-3 py-2 w-90">
                                        ⚠️ {duplicateMsg}
                                    </div>
                                </div>
                            )}

                            {selectedType === 'new' && (
                                <div className="mt-6 border-t pt-4">
                                    <div className="font-bold text-lg mb-2">Advanced options</div>
                                    <div className="flex flex-col gap-3">
                                        <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={!skipInbox}
                                                onChange={(e) => setSkipInbox(!e.target.checked)}
                                            />
                                            New emails should skip the inbox
                                        </label>
                                        <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={skipReplies}
                                                onChange={(e) => setSkipReplies(e.target.checked)}
                                            />
                                            Replies to existing conversations already on the board should skip the inbox
                                        </label>
                                        <label className="flex items-center gap-2">
                                            <input
                                                type="checkbox"
                                                checked={runOnExistingEmails}
                                                onChange={(e) => setRunOnExistingEmails(e.target.checked)}
                                            />

                                            Run this automation on existing emails in the Inbox, going back

                                            <select value={days} onChange={(e) => setDays(e.target.value)}>
                                                {Array.from({ length: 10 }, (_, i) => i + 1).map((day) => (
                                                    <option key={day} value={day}>
                                                        {day} day{day > 1 ? "s" : ""}
                                                    </option>
                                                ))}
                                                <option value="365" >1 year</option>
                                            </select>
                                        </label>


                                    </div>
                                </div>
                            )}










                            {selectedType == 'itemAdded' && (
                                <>
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">if</span>
                                        <select className="border border-gray-300 rounded px-3 py-2 w-[270px] bg-white">
                                            <option>the board</option>
                                        </select>
                                        <select
                                            className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                            disabled
                                        >
                                            <option>is</option>
                                        </select>
                                        <div className="flex flex-col items-start gap-1">
                                            <select
                                                className="border border-gray-300  w-[450px] rounded px-3 py-2  bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName &&
                                                    boardName.length > 0 &&
                                                    boardName.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {Array.isArray(conditions) &&
                                        conditions.map((cond, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-1">
                                                <span className="font-medium text-gray-700 w-[60px]">and</span>
                                                <select
                                                    className="border border-gray-300 rounded  w-[270px] px-3 py-2 bg-white"
                                                    value={cond.field}
                                                    onChange={(e) => updateConditionField(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        choose an option...
                                                    </option>
                                                    {completedConditionOptions
                                                        .filter(
                                                            (opt) =>
                                                                !selectedIsFields.includes(opt.value) ||
                                                                cond.field === opt.value,
                                                        )
                                                        .map((opt, i) => (
                                                            <option key={i} value={opt.value}>
                                                                {opt.label}
                                                            </option>
                                                        ))}
                                                </select>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 w-[200px] bg-white"
                                                    value={cond.operator}
                                                    onChange={(e) => updateConditionOperator(index, e.target.value)}
                                                >
                                                    {operatorOptions.map((op, i) => (
                                                        <option key={i} value={op.value}>
                                                            {op.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {cond?.field === 'assignee' && (
                                                    <select
                                                        className="border border-gray-300  w-[450px] rounded px-3 py-2  bg-white"
                                                        value={cond.value || ''}
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    >
                                                        <option value="" disabled>
                                                            Choose user...
                                                        </option>
                                                        {userData.map((item, i) => (
                                                            <option key={i} value={item.id}>
                                                                {item.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}
                                                {(cond?.field === 'title' ||
                                                    cond?.field === 'sender' ||
                                                    cond?.field === 'recipient') && (
                                                        <input
                                                            type="text"
                                                            className="border border-gray-300 w-[450px] rounded px-3 py-2 bg-white"
                                                            value={cond.value}
                                                            placeholder="specify..."
                                                            onChange={(e) => updateConditionValue(index, e.target.value)}
                                                        />
                                                    )}
                                                {cond.field === 'listName' && (
                                                    <select
                                                        className="border border-gray-300 w-[450px] rounded px-3 py-2 bg-white"
                                                        value={cond.value || ''}
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    >
                                                        <option value="" disabled>
                                                            Choose a list...
                                                        </option>
                                                        {selectedBoardColumn.map((item, i) => (
                                                            <option key={i} value={item.id}>
                                                                {item.coloum}
                                                            </option>
                                                        ))}
                                                    </select>
                                                )}

                                                {conditions.length > 1 && (
                                                    <button
                                                        onClick={() => removeCondition(index)}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>

                                    <div>
                                        {actionRows.map((row, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-2 mt-4">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'Then' : 'and'}
                                                </span>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2  w-[270px] bg-white"
                                                    value={row.action}
                                                    onChange={(e) => updateAction(index, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>
                                                    {conditionThenOption.map((item, idx) => (
                                                        <option key={idx} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>


                                                {showUserSelectFor.includes(row.action) &&
                                                    (row.action === 'assignToRoundRobin' ? (
                                                        <Select
                                                            isMulti
                                                            options={options}
                                                            className="border border-gray-300 rounded w-[500px] py-[1px]"
                                                            placeholder="Select users"
                                                            value={row.users || []}
                                                            onChange={(selected) => updateUser(index, selected, true)}
                                                        />
                                                    ) : row.action === "assignTo" ? (
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateUser(index, e.target.value)}
                                                        >
                                                            <option value="">Select user</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    ) : row.action === "setEmailLabel" ? (
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white"
                                                            value={
                                                                row.user
                                                                    ? JSON.stringify({
                                                                        parentId: row.user.parentId || null,
                                                                        childId: row.user.id,
                                                                        name: row.user.name,
                                                                    })
                                                                    : ''
                                                            }
                                                            onChange={(e) => handleLabelChange(index, e.target.value)}
                                                        >
                                                            <option value="">Select label</option>
                                                            {lables.map((label) => {
                                                                const options = [];


                                                                options.push(
                                                                    <option
                                                                        key={label.id}
                                                                        value={JSON.stringify({ parentId: null, childId: label.id, name: label.name })}
                                                                    >
                                                                        {label.name}
                                                                    </option>
                                                                );


                                                                if (label.children && label.children.length > 0) {
                                                                    label.children.forEach((child) => {
                                                                        options.push(
                                                                            <option
                                                                                key={child.id}
                                                                                value={JSON.stringify({ parentId: label.id, childId: child.id, name: child.name })}
                                                                            >
                                                                                {label.name}/{child.name}
                                                                            </option>
                                                                        );
                                                                    });
                                                                }

                                                                return options;
                                                            })}
                                                        </select>
                                                    ) : null
                                                    )}

                                                {row.action === 'setCustomProperty' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white mt-3"
                                                            value={row.propertyId || row.customProperty}
                                                            onChange={(e) => handlePropertySelect(index, e.target.value)}
                                                        >
                                                            <option value="">Select property</option>
                                                            {customPropertyOptions.map((prop, j) => (
                                                                <option key={j} value={prop.value}>
                                                                    {prop.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="mt-3 w-50">
                                                            {customFieldLoadingByRow[index] ? (
                                                                <p className="text-sm text-gray-500">Loading fields...</p>
                                                            ) : customFieldErrorByRow[index] ? (
                                                                <p className="text-sm text-red-500">{customFieldErrorByRow[index]}</p>
                                                            ) : Array.isArray(customFieldOptionsByRow[index]) && customFieldOptionsByRow[index].length > 0 ? (
                                                                <>
                                                                    <AutomationStatusDropdown idx={index} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                        setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                            handleUpdatedCustomField
                                                                        } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </>)}

                                                {row.action === 'createOnList' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 rounded w-[200px]  px-3 py-2  bg-white"
                                                            value={row.boardId || ''}
                                                            onChange={(e) => {
                                                                updateAction(index, e.target.value),
                                                                    getSELECTED_BOARD(e.target.value);
                                                            }}
                                                        >
                                                            <option value="" disabled>
                                                                Choose a board...
                                                            </option>
                                                            {boardName.map((item) => (
                                                                <option key={item.value} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        <select
                                                            className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                            value={row.entityId || ''}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="" disabled>
                                                                Choose a list...
                                                            </option>
                                                            {selectedBoardColumn.map((item, i) => (
                                                                <option key={i} value={item.id}>
                                                                    {item.coloum}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </>
                                                )}

                                                {actionRows.length > 1 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(index, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}


                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    </div>
                                </>
                            )}

                            {selectedType === 'noReplyToCustomer' && (
                                <>
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">if</span>
                                        <select className="border border-gray-300 rounded px-3 py-2   w-[270px] bg-white">
                                            <option>the board</option>
                                        </select>
                                        <select
                                            className="border border-gray-300 rounded  w-[200px] px-3 py-2 bg-white"
                                            disabled
                                        >
                                            <option>is</option>
                                        </select>
                                        <div className="flex flex-col items-start gap-1">
                                            <select
                                                className="border border-gray-300  w-[450px] rounded px-3 py-2 bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName &&
                                                    boardName.length > 0 &&
                                                    boardName.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {conditions.map((cond, index) => (
                                        <div key={index} className="flex items-center gap-3 mb-1">
                                            <span className="font-medium text-gray-700 w-[60px]">and</span>

                                            <select
                                                className="border border-gray-300 rounded  w-[270px] px-3 py-2 bg-white"
                                                value={cond.field}
                                                onChange={(e) => updateConditionField(index, e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    choose an option...
                                                </option>

                                                {(index === 0
                                                    ? [
                                                        {
                                                            label: 'the customer has been waiting',
                                                            value: 'customerWaiting',
                                                        },
                                                    ]
                                                    : ConditionOptions
                                                )
                                                    .filter(
                                                        (opt) =>
                                                            !selectedIsFields.includes(opt.value) ||
                                                            cond.field === opt.value,
                                                    )
                                                    .map((opt, i) => (
                                                        <option key={i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded  w-[200px] px-3 py-2 bg-white"
                                                value={cond.operator}
                                                onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            >

                                                {(cond.field === 'assignee'
                                                    ? [{ label: 'is', value: 'equals' }]
                                                    : index === 0
                                                        ? no_reply_to_customer
                                                        : operatorOptions
                                                ).map((opt, i) => (

                                                    <option key={i} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>

                                            {index === 0 && (
                                                <div className="flex flex-col">
                                                    <input
                                                        type="number"
                                                        className={`border rounded w-[450px] px-3 py-2 bg-white ${cond.operator === 'moreThanMins' &&
                                                            parseInt(cond.value) < 2 &&
                                                            cond.value !== ''
                                                            ? 'border-red-500'
                                                            : 'border-gray-300'
                                                            }`}
                                                        value={cond.value}
                                                        min="2"
                                                        placeholder="specify...."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                    {cond.operator === 'moreThanMins' &&
                                                        parseInt(cond.value) < 2 &&
                                                        cond.value !== '' && (
                                                            <span className="text-xs mt-1 text-red-500">
                                                                Error: Minutes must be at least 15 for SLA alerts
                                                            </span>
                                                        )}
                                                </div>
                                            )}

                                            {cond?.field === 'assignee' && (
                                                <select
                                                    className="border border-gray-300 rounded px-3  w-[450px] py-2  bg-white"
                                                    value={cond.value}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose user...
                                                    </option>
                                                    {userData.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            {(cond?.field === 'title' ||
                                                cond?.field === 'sender' ||
                                                cond?.field === 'recipient') && (
                                                    <input
                                                        type="text"
                                                        className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                        value={cond.value}
                                                        placeholder="specify..."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                )}
                                            {cond.field === 'listName' && (
                                                <select
                                                    className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                    value={cond.value || ''}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose a list...
                                                    </option>
                                                    {selectedBoardColumn.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.coloum}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>

                                    <div>
                                        {actionRows.map((row, index) => (
                                            <div key={index} className="flex  gap-3 mb-2 ">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'Then' : 'and'}
                                                </span>

                                                <select
                                                    className="border h-[fit-content] border-gray-300 rounded px-3  w-[270px] py-2 bg-white "
                                                    value={row.action}
                                                    onChange={(e) => updateAction(index, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>
                                                    {no_reply_then_condition.map((item, idx) => (
                                                        <option key={idx} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {row.action === 'setSlaAlertTag' && (
                                                    <>
                                                        <Select
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={formattedOptions}
                                                            value={formattedOptions.filter((item) =>
                                                                (row.entityId || []).includes(item.value),
                                                            )}
                                                            onChange={(selectedOptions) =>
                                                                updateBoardList(
                                                                    index,
                                                                    selectedOptions.map((opt) => opt.value),
                                                                )
                                                            }
                                                            placeholder="Choose SLA alerts..."
                                                            className="w-[500px]  border border-gray-300 rounded "
                                                            styles={customStyles}
                                                            components={{
                                                                MultiValue,
                                                                MultiValueRemove: () => null,
                                                                Option,
                                                            }}
                                                        />
                                                    </>
                                                )}
                                                {

                                                    row.action === 'setEmailLabel' && (
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white"
                                                            value={
                                                                row.user
                                                                    ? JSON.stringify({
                                                                        parentId: row.user.parentId || null,
                                                                        childId: row.user.id,
                                                                        name: row.user.name,
                                                                    })
                                                                    : ''
                                                            }
                                                            onChange={(e) => handleLabelChange(index, e.target.value)}
                                                        >
                                                            <option value="">Select label</option>
                                                            {lables.map((label) => {
                                                                const options = [];


                                                                options.push(
                                                                    <option
                                                                        key={label.id}
                                                                        value={JSON.stringify({ parentId: null, childId: label.id, name: label.name })}
                                                                    >
                                                                        {label.name}
                                                                    </option>
                                                                );


                                                                if (label.children && label.children.length > 0) {
                                                                    label.children.forEach((child) => {
                                                                        options.push(
                                                                            <option
                                                                                key={child.id}
                                                                                value={JSON.stringify({ parentId: label.id, childId: child.id, name: child.name })}
                                                                            >
                                                                                {label.name}/{child.name}
                                                                            </option>
                                                                        );
                                                                    });
                                                                }

                                                                return options;
                                                            })}
                                                        </select>

                                                    )


                                                }

                                                {row.action === 'setCustomProperty' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white "
                                                            value={row.propertyId || row.customProperty}
                                                            onChange={(e) => handlePropertySelect(index, e.target.value)}
                                                        >
                                                            <option value="">Select property</option>
                                                            {customPropertyOptions.map((prop, j) => (
                                                                <option key={j} value={prop.value}>
                                                                    {prop.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className=" w-50">
                                                            {customFieldLoadingByRow[index] ? (
                                                                <p className="text-sm text-gray-500">Loading fields...</p>
                                                            ) : customFieldErrorByRow[index] ? (
                                                                <p className="text-sm text-red-500">{customFieldErrorByRow[index]}</p>
                                                            ) : Array.isArray(customFieldOptionsByRow[index]) && customFieldOptionsByRow[index].length > 0 ? (
                                                                <>
                                                                    <AutomationStatusDropdown idx={index} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                        setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                            handleUpdatedCustomField
                                                                        } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </>)}

                                                {row.action === 'sendOverdueAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 h-[fit-content] w-[200px] rounded px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300  w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm  text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="🔥Overdue - Customer is waiting for a reply."
                                                                style={{ background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendUpcomingAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[200px]  h-[fit-content] rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 h-[fit-content] w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="⚡Upcoming soon - Don’t forget"
                                                                style={{ background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendNotificationTo' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 h-[fit-content] rounded w-[200px] px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="Issue escalated to you"
                                                                style={{ background: 'transparent' }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {actionRows.length > 1 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(index, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}


                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    </div>
                                </>
                            )}

                            {selectedType === 'noReplyFromCustomer' && (
                                <>
                                    <div className="flex items-center gap-3 mb-1">
                                        <span className="font-medium text-gray-700 w-[60px]">if</span>
                                        <select className="border border-gray-300  w-[270px] rounded px-3 py-2  bg-white">
                                            <option>the board</option>
                                        </select>
                                        <select
                                            className="border border-gray-300 w-[200px] rounded px-3 py-2 bg-white"
                                            disabled
                                        >
                                            <option>is</option>
                                        </select>
                                        <div className="flex flex-col items-start gap-1">
                                            <select
                                                className="border border-gray-300  w-[450px] rounded px-3 py-2 bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName &&
                                                    boardName.length > 0 &&
                                                    boardName.map((item) => (
                                                        <option key={item.value} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>

                                    {conditions.map((cond, index) => (
                                        <div key={index} className="flex items-center gap-3 mb-1">
                                            <span className="font-medium text-gray-700 w-[60px]">and</span>

                                            <select
                                                className="border border-gray-300  w-[270px] rounded px-3 py-2 bg-white"
                                                value={cond.field}
                                                onChange={(e) => updateConditionField(index, e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    choose an option...
                                                </option>

                                                {(index === 0
                                                    ? [
                                                        {
                                                            label: 'the team has been waiting',
                                                            value: 'customerNotResponding',
                                                        },
                                                    ]
                                                    : ConditionOptions
                                                )
                                                    .filter(
                                                        (opt) =>
                                                            !selectedIsFields.includes(opt.value) ||
                                                            cond.field === opt.value,
                                                    )
                                                    .map((opt, i) => (
                                                        <option key={i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3  w-[200px] py-2 bg-white"
                                                value={cond.operator}
                                                onChange={(e) => updateConditionOperator(index, e.target.value)}
                                            >


                                                {(cond.field === 'assignee'
                                                    ? [{ label: 'is', value: 'equals' }]
                                                    : index === 0
                                                        ? no_reply_to_customer
                                                        : operatorOptions
                                                ).map((opt, i) => (
                                                    <option key={i} value={opt.value}>
                                                        {opt.label}
                                                    </option>
                                                ))}
                                            </select>

                                            {index === 0 && (
                                                <div className="flex flex-col">
                                                    <input
                                                        type="number"
                                                        className={`border rounded px-3 py-2 w-[450px] bg-white ${cond.operator === 'moreThanMins' &&
                                                            parseInt(cond.value) < 2 &&
                                                            cond.value !== ''
                                                            ? 'border-red-500'
                                                            : 'border-gray-300'
                                                            }`}
                                                        value={cond.value}
                                                        min="2"
                                                        placeholder="specify...."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                    {cond.operator === 'moreThanMins' &&
                                                        parseInt(cond.value) < 2 &&
                                                        cond.value !== '' && (
                                                            <span className="text-xs mt-1 text-red-500">
                                                                Error: Minutes must be at least 15 for SLA alerts
                                                            </span>
                                                        )}
                                                </div>
                                            )}
                                            {cond?.field === 'assignee' && (
                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2  w-[450px]  bg-white"
                                                    value={cond.value}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose user...
                                                    </option>
                                                    {userData.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            {(cond?.field === 'title' ||
                                                cond?.field === 'sender' ||
                                                cond?.field === 'recipient') && (
                                                    <input
                                                        type="text"
                                                        className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                        value={cond.value}
                                                        placeholder="specify..."
                                                        onChange={(e) => updateConditionValue(index, e.target.value)}
                                                    />
                                                )}
                                            {cond.field === 'listName' && (
                                                <select
                                                    className="border border-gray-300 rounded  w-[450px] px-3 py-2 bg-white"
                                                    value={cond.value || ''}
                                                    onChange={(e) => updateConditionValue(index, e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Choose a list...
                                                    </option>
                                                    {selectedBoardColumn.map((item, i) => (
                                                        <option key={i} value={item.id}>
                                                            {item.coloum}
                                                        </option>
                                                    ))}
                                                </select>
                                            )}
                                            <button
                                                onClick={() => removeCondition(index)}
                                                className="text-red-500 fonst-bold text-xl px-2"
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}

                                    <div>
                                        <a
                                            onClick={addCondition}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                        >
                                            + Add condition
                                        </a>
                                    </div>

                                    <div>
                                        {actionRows.map((row, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-2 mt-4">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'Then' : 'and'}
                                                </span>

                                                <select
                                                    className="border border-gray-300 rounded  w-[270px] px-3 py-2 bg-white "
                                                    value={row.action}
                                                    onChange={(e) => updateAction(index, e.target.value)}
                                                >
                                                    <option value="">Select Action</option>
                                                    {no_reply_then_condition.map((item, idx) => (
                                                        <option key={idx} value={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                {row.action === 'setSlaAlertTag' && (
                                                    <>
                                                        <Select
                                                            isMulti
                                                            closeMenuOnSelect={false}
                                                            options={formattedOptions}
                                                            value={formattedOptions.filter((item) =>
                                                                (row.entityId || []).includes(item.value),
                                                            )}
                                                            onChange={(selectedOptions) =>
                                                                updateBoardList(
                                                                    index,
                                                                    selectedOptions.map((opt) => opt.value),
                                                                )
                                                            }
                                                            placeholder="Choose SLA alerts..."
                                                            className="w-[500px]"
                                                            styles={customStyles}
                                                            components={{
                                                                MultiValue,
                                                                MultiValueRemove: () => null,
                                                                Option,
                                                            }}
                                                        />
                                                    </>
                                                )}


                                                {row.action === 'setEmailLabel' && (
                                                    <select
                                                        className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white"
                                                        value={
                                                            row.user
                                                                ? JSON.stringify({
                                                                    parentId: row.user.parentId || null,
                                                                    childId: row.user.id,
                                                                    name: row.user.name,
                                                                })
                                                                : ''
                                                        }
                                                        onChange={(e) => handleLabelChange(index, e.target.value)}
                                                    >
                                                        <option value="">Select label</option>
                                                        {lables.map((label) => {
                                                            const options = [];


                                                            options.push(
                                                                <option
                                                                    key={label.id}
                                                                    value={JSON.stringify({ parentId: null, childId: label.id, name: label.name })}
                                                                >
                                                                    {label.name}
                                                                </option>
                                                            );

                                                            if (label.children && label.children.length > 0) {
                                                                label.children.forEach((child) => {
                                                                    options.push(
                                                                        <option
                                                                            key={child.id}
                                                                            value={JSON.stringify({ parentId: label.id, childId: child.id, name: child.name })}
                                                                        >
                                                                            {label.name}/{child.name}
                                                                        </option>
                                                                    );
                                                                });
                                                            }

                                                            return options;
                                                        })}
                                                    </select>
                                                )}
                                                {row.action === 'setCustomProperty' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[500px] rounded px-3 py-2 bg-white "
                                                            value={row.propertyId || row.customProperty}
                                                            onChange={(e) => handlePropertySelect(index, e.target.value)}
                                                        >
                                                            <option value="">Select property</option>
                                                            {customPropertyOptions.map((prop, j) => (
                                                                <option key={j} value={prop.value}>
                                                                    {prop.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className=" w-50">
                                                            {customFieldLoadingByRow[index] ? (
                                                                <p className="text-sm text-gray-500">Loading fields...</p>
                                                            ) : customFieldErrorByRow[index] ? (
                                                                <p className="text-sm text-red-500">{customFieldErrorByRow[index]}</p>
                                                            ) : Array.isArray(customFieldOptionsByRow[index]) && customFieldOptionsByRow[index].length > 0 ? (
                                                                <>
                                                                    <AutomationStatusDropdown idx={index} setSelectedCustomFieldByRow={setSelectedCustomFieldByRow} customFieldOptionsByRow={customFieldOptionsByRow} selectedCustomFieldByRow={selectedCustomFieldByRow} getDefaultColorByValue={getDefaultColorByValue} customeFiedId={customeFiedId}
                                                                        setCustomeFieldId={setCustomeFieldId} handleUpdateCell={handleUpdateCell} propertyId={row?.propertyId || row.customProperty} handleUpdatedCustomField={
                                                                            handleUpdatedCustomField
                                                                        } deleteCustomField={deleteCustomField} setCustomFieldOptionsByRow={setCustomFieldOptionsByRow} />
                                                                </>
                                                            ) : null}
                                                        </div>
                                                    </>)}

                                                {row.action === 'sendOverdueAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 h-[fit-content] w-[200px] rounded px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 rounded px-3 py-2 bg-white w-[450px]">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="🔥Overdue - Customer is waiting for a reply."
                                                                style={{
                                                                    paddingRight: '1rem',
                                                                    background: 'transparent',
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendUpcomingAlert' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300 w-[200px]  h-[fit-content] rounded px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300  h-[fit-content] w-[450px] rounded px-3 py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="⚡Upcoming soon - Don’t forget"
                                                                style={{
                                                                    paddingRight: '1rem',
                                                                    background: 'transparent',
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {row.action === 'sendNotificationTo' && (
                                                    <>
                                                        <select
                                                            className="border border-gray-300  h-[fit-content] rounded w-[200px] px-3 py-2 bg-white"
                                                            value={row.entityId}
                                                            onChange={(e) => updateBoardList(index, e.target.value)}
                                                        >
                                                            <option value="">Assignee</option>
                                                            {options.map((user, j) => (
                                                                <option key={j} value={user.value}>
                                                                    {user.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        <div className="relative border border-gray-300 rounded px-3 w-[450px] py-2 bg-white">
                                                            <textarea
                                                                className="w-full text-sm text-black placeholder-gray-400 focus:outline-none resize-none"
                                                                value={row.message}
                                                                onChange={(e) => updateMessage(index, e.target.value)}
                                                                placeholder="Issue escalated to you"
                                                                style={{
                                                                    paddingRight: '1rem',
                                                                    background: 'transparent',
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                )}
                                                {actionRows.length > 1 && (
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(index, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="text-red-500 fonst-bold text-xl px-2"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}


                                        <a
                                            onClick={addActionRow}
                                            className="text-blue-500 font-bold px-4 py-2 text-decoration-none"
                                            style={{ minWidth: '120px' }}
                                            type="button"
                                        >
                                            + Add action
                                        </a>
                                    </div>
                                </>
                            )}
                            {(selectedType === 'completed' ||
                                selectedType === 'reopened' ||
                                selectedType === 'customer' ||
                                selectedType === 'assigned') && (
                                    <>
                                        {conditions.map((cond, index) => (
                                            <div key={index} className="flex items-center gap-3 mb-1">
                                                <span className="font-medium text-gray-700 w-[60px]">
                                                    {index === 0 ? 'if' : 'and'}
                                                </span>

                                                <select className="border border-gray-300 rounded px-3 py-2  bg-white">
                                                    <option value="" disabled>
                                                        choose an option...
                                                    </option>
                                                    {(index === 0
                                                        ? [{ label: 'the board', value: 'board' }]
                                                        : selectedType === 'completed' || selectedType === 'assigned'
                                                            ? completedConditionOptions
                                                            : customPropertyThenOption
                                                    ).map((opt, i) => (
                                                        <option key={opt.value || i} value={opt.value}>
                                                            {opt.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                <select
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white"


                                                >
                                                    {index === 0
                                                        ? ['is'].map((op, i) => (
                                                            <option key={i} value={op}>
                                                                {op}
                                                            </option>
                                                        ))
                                                        : operatorOptions.map((op, i) => (
                                                            <option key={i} value={op}>
                                                                {op}
                                                            </option>
                                                        ))}
                                                </select>

                                                <input
                                                    type="text"
                                                    className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                />

                                                {conditions.length > 0 && (
                                                    <button
                                                        onClick={() => removeCondition(index)}
                                                        className="text-red-500 font-bold text-xl px-2"
                                                    >
                                                        ×
                                                    </button>
                                                )}
                                            </div>
                                        ))}

                                        <div>
                                            <a
                                                onClick={addCondition}
                                                className="text-blue-500 font-bold px-4 py-2 text-decoration-none "
                                            >
                                                + Add condition
                                            </a>
                                        </div>


                                        <div className="flex items-center gap-3 mb-1 mt-4">
                                            <span className="font-medium text-gray-700 w-[60px]">Then</span>

                                            <select className="border border-gray-300 rounded px-3 py-2 bg-white">
                                                {conditionThenOption.map((item, i) => (
                                                    <option key={i} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3 py-2  bg-white"
                                                value={boardSelect}
                                                onChange={(e) => handleBoardChange(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a board...
                                                </option>
                                                {boardName?.map((item) => (
                                                    <option key={item.value} value={item.value}>
                                                        {item.label}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                className="border border-gray-300 rounded px-3 py-2  bg-white"
                                                value={boardColumnSelect}
                                                onChange={(e) => setBoardColumnSelect(e.target.value)}
                                            >
                                                <option value="" disabled>
                                                    Choose a list...
                                                </option>
                                                {selectedBoardColumn?.map((item, i) => (
                                                    <option key={i} value={item.id}>
                                                        {item.coloum}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div>
                                            {actionRows.map((row, i) => (
                                                <div key={i} className="flex items-center gap-3 mb-2 mt-4">
                                                    <span className="font-medium text-gray-700 w-[60px]">and</span>
                                                    <select
                                                        className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                        value={row.action}
                                                        onChange={(e) => updateAction(i, e.target.value)}
                                                    >
                                                        <option value="">Select Action</option>
                                                        {(i === 0 ? availableActions : availableActions.slice(3)).map(
                                                            (item, idx) => (
                                                                <option key={idx} value={item.value}>
                                                                    {item.label}
                                                                </option>
                                                            ),
                                                        )}
                                                    </select>
                                                    {showUserSelectFor.includes(row.action) && (
                                                        <select
                                                            className="border border-gray-300 rounded px-3 py-2 bg-white"
                                                            value={row.user}
                                                            onChange={(e) => updateUser(i, e.target.value)}
                                                        >
                                                            <option value="">demo</option>
                                                            {userData.map((user, j) => (
                                                                <option key={j} value={user.id}>
                                                                    {user.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    )}
                                                    <button
                                                        onClick={() => {
                                                            const updated = [...actionRows];
                                                            updated.splice(i, 1);
                                                            setActionRows(updated);
                                                        }}
                                                        className="ml-2  w-8 h-8 flex items-center justify-center text-lg font-bold"
                                                        title="Remove action"
                                                        type="button"
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                            {!shouldHideAddButton && (
                                                <a
                                                    onClick={addActionRow}
                                                    className="text-blue-500 font-bold px-4 py-2  text-decoration-none"
                                                    style={{ minWidth: '120px' }}
                                                    type="button"
                                                >
                                                    + Add action
                                                </a>
                                            )}
                                        </div>
                                    </>
                                )}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="flex justify-end w-full">
                    <button
                        className=" text-gray-800 border font-google border-solid border-[#bdbdbd]  font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline mr-2"
                        onClick={() => setStep(1)}
                    >
                        Cancel
                    </button>
                    <button
                        // disabled={isDuplicate}
                        className={`font-google text-white font-bold py-2 px-4 font-normal rounded focus:outline-none focus:shadow-outline
                           bg-blue-500 hover:bg-blue-700 cursor-pointer
                            `}
                        onClick={() => {
                            if (!boardSelect) {
                                toast.error('Please Select Board');
                                return;
                            } else if (selectedType === 'new' && !selectedMailUser) {
                                toast.error('Please Select Gmail User');
                                return;
                            }
                            // else if (isDuplicate) {
                            //     if (selectedType === 'new') {
                            //         toast.error('Automation already exists for this board ');
                            //     } else {
                            //         toast.error(`Automation of type "${selectedType}" already exists for this board.`);
                            //     }
                            //     return;
                            // } 
                            else {

                                const hasInvalidMinutes = conditions.some((cond) => {
                                    if (cond.operator === 'moreThanMins' && cond.field === 'customerWaiting') {
                                        const minutes = parseInt(cond.value);
                                        return isNaN(minutes) || minutes < 2;
                                    }
                                    if (cond.operator === 'moreThanMins' && cond.field === 'teamWaiting') {
                                        const minutes = parseInt(cond.value);
                                        return isNaN(minutes) || minutes < 2;
                                    }
                                    return false;
                                });

                                if (hasInvalidMinutes) {

                                    return;
                                }

                                handleCreate();
                            }
                        }}
                    >
                        {editId ? 'Update' : 'Create'}
                    </button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default Automation;
